import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Receipt } from 'lucide-react';
import { UpcomingBilling as Row, quoteApi } from '../../services/quoteApi';

/** 다가오는 청구(작업 10 알림) — 수행 중 프로젝트의 회차 중 30일 안 · 지난 것. 없으면 칸이 없다 */
export const UpcomingBilling: React.FC = () => {
  const [rows, setRows] = useState<Row[]>([]);
  const navigate = useNavigate();
  useEffect(() => { quoteApi.upcoming(30).then(setRows).catch(() => setRows([])); }, []);
  if (!rows.length) return null;
  return (
    <div className="mb-4 rounded-lg border border-amber-200 bg-amber-50 px-4 py-2.5">
      <p className="text-sm font-semibold text-amber-800 flex items-center gap-1.5"><Receipt size={14} /> 다가오는 청구 {rows.length}건</p>
      <ul className="mt-1 space-y-0.5">
        {rows.map((r, i) => (
          <li key={i} className="text-sm">
            <button onClick={() => navigate(`/projects/${r.projectId}?step=output`)} className="hover:underline text-left">
              <span className={r.overdue ? 'text-red-600 font-medium' : 'text-amber-900'}>{r.dueDate}{r.overdue ? ' (지남)' : ''}</span>
              <span className="text-slate-700"> · {r.projectName} · {r.name} · {Math.round(r.amount).toLocaleString('ko-KR')}원</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
